import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminSidebar } from '../components/admin/AdminSidebar';
import { AdminOverview } from '../components/admin/AdminOverview';
import { PackageManager } from '../components/admin/PackageManager';
import { InvoiceManager } from '../components/admin/InvoiceManager';
import { TicketManager } from '../components/admin/TicketManager';
import { StaffManager } from '../components/admin/StaffManager';
import { ServerIntegrations } from '../components/admin/ServerIntegrations';
import { ThemeEditor } from '../components/admin/ThemeEditor';
import { CustomerManager } from '../components/admin/CustomerManager';
import { DomainManager } from '../components/admin/DomainManager';
import { PaymentGatewayManager } from '../components/admin/PaymentGatewayManager';
export function AdminDashboard() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  return <div className="min-h-screen bg-slate-900 flex" data-id="element-1413">
      <AdminSidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} data-id="element-1414" />

      <main className="flex-1 lg:ml-64 pt-16 lg:pt-0" data-id="element-1415">
        <div className="p-6 md:p-10 max-w-7xl mx-auto" data-id="element-1416">
          <Routes data-id="element-1417">
            <Route path="/" element={<AdminOverview data-id="element-1419" />} data-id="element-1418" />
            <Route path="/packages" element={<PackageManager data-id="element-1421" />} data-id="element-1420" />
            <Route path="/invoices" element={<InvoiceManager data-id="element-1423" />} data-id="element-1422" />
            <Route path="/tickets" element={<TicketManager data-id="element-1425" />} data-id="element-1424" />
            <Route path="/staff" element={<StaffManager data-id="element-1427" />} data-id="element-1426" />
            <Route path="/servers" element={<ServerIntegrations data-id="element-1429" />} data-id="element-1428" />
            <Route path="/theme" element={<ThemeEditor data-id="element-1431" />} data-id="element-1430" />
            <Route path="/customers" element={<CustomerManager data-id="element-1433" />} data-id="element-1432" />
            <Route path="/domains" element={<DomainManager data-id="element-1435" />} data-id="element-1434" />
            <Route path="/gateways" element={<PaymentGatewayManager data-id="element-1437" />} data-id="element-1436" />
            <Route path="*" element={<Navigate to="/admin" replace data-id="element-1439" />} data-id="element-1438" />
          </Routes>
        </div>
      </main>
    </div>;
}